import type { Notification } from "@/context/notification"

export function hasUnseenResponseNotification(notifications: Notification[]) {
  return notifications.some((notification) => notification.type === "turn-complete")
}
